<template>
    <div class="shuffling-box">
        <Title :title="swiper.title"/>

        <div class="swiper-box">
            <swiper
            ref="mySwiper"
            :options="swiperOptions"
            style="cursor: pointer;">
                <swiper-slide
                v-for="(item, index) in swiper.list"
                :key="index">
                    <el-link
                    v-if="item.url != ''"
                    :href="item.url"
                    target="_blank"
                    :underline="false">
                        <img
                        :src="item.img"
                        lazy>
                    </el-link>

                    <img
                    v-else
                    :src="item.img"
                    lazy>
                </swiper-slide>
            </swiper>

            <!-- <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div> -->
        </div>
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'

export default {
    name: 'Shuffling',
    props: ['swiper'],
    components: {
        Swiper,
        SwiperSlide
    },
    data() {
        return {
            swiperOptions: {
                loop: true,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false,
                    waitForTransition: false,
                },
                // navigation: {
                //     nextEl: '.swiper-button-next',
                //     prevEl: '.swiper-button-prev',
                // },
            },
        }
    }
}
</script>

<style scoped>
.shuffling-box {
    margin-top: 10px;
}

.swiper-box {
    position: relative;
}

.swiper-box .swiper-container {
    max-width: 790px;
    height: 450px;
}

.swiper-box img {
    width: 100%;
    height: 100%;
}

@media(max-width: 1100px) {
    .swiper-box .swiper-container {
        height: 200px;
    }
}
</style>
